// import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import CallOutlined from "@material-ui/icons/CallOutlined"
import EmailOutlined from "@material-ui/icons/EmailOutlined"
import { FaWhatsapp } from "react-icons/fa"
import ExternalLink from "@material-ui/core/Link"
import MuiLink from "../bits/Link"
import clsx from "../../util/clsx"
import Map from "../bits/Map"

const useStyles = makeStyles(theme => ({
  Section: {
    background: theme.palette.background.paper,
  },
  Container: {
    margin: "auto",
    padding: theme.spacing(2, 1),
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: 1200,
    },
  },
  Grid: {
    paddingTop: theme.spacing(2),
  },
  GridItem: {},
  GridItemI: {
    paddingTop: theme.spacing(6),
  },
  GridItemII: {},
  GridItemIII: {},
  List: {},
  ListItem: {
    paddingLeft: 0,
  },
  em: {
    color: theme.palette.text.primary,
  },
  IconBox: {
    minWidth: 30,
    display: "inline-block",
    "& ~ div": {
      display: "inline-block",
      padding: "auto",
      fontSize: theme.typography.fontSize + 2,
    },
  },
  Icon: {
    color: theme.palette.text.primary,
    fontSize: theme.spacing(2.5),
  },
  Ruler: {
    padding: theme.spacing(1),
    "& div": {
      background: theme.palette.background.default,
      borderRadius: 3,
      height: theme.spacing(0.5),
      margin: "auto",
      width: theme.spacing(15),
    },
  },
  Logo: {
    fontFamily: "Montserrat Alternates",
    flexGrow: 1,
    alignSelf: "end",
    fontSize: theme.typography.fontSize + 35,
    fontWeight: 900,
    padding: 0,
    paddingRight: 10,
    [theme.breakpoints.down(1200)]: {
      fontSize: theme.typography.fontSize + 30,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.fontSize + 12,
      paddingBottom: 10,
    },
  },
  BottomNav: {
    padding: 0,
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      border: "1px solid yellow",
      textAlign: "center",
    },

    "& li": {
      [theme.breakpoints.up("sm")]: {
        textAlign: "center",
        display: "inline",
      },
    },
    "& li:first-of-type": {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: 0,
      },
    },
  },
  alignLeft: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "end",
    },
    "& > p": {
      paddingRight: theme.spacing(2),
    },
    "& span, & p": {
      [theme.breakpoints.down("sm")]: {
        textAlign: "end",
      },
    },
  },
  paddingLeft: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
    },
  },
  lowerCase: {
    textTransform: "lowercase",
  },
}))
const Footer = ({ siteTitle }) => {
  const classes = useStyles()
  return (
    <Box className={classes.Section}>
      <Box className={classes.Container}>
        <Box className={classes.Ruler}>
          <Box></Box>
        </Box>
        <Grid container className={classes.Grid}>
          <Grid
            container
            item
            className={clsx([classes.GridItem, classes.GridItemI])}
            xs
          >
            <Grid item xs className={classes.paddingLeft}>
              <Typography>CONTACT US</Typography>
              <List className={classes.List}>
                <ListItem className={classes.ListItem}>
                  <Button
                    component={ExternalLink}
                    startIcon={<CallOutlined />}
                    color="primary"
                    underline="none"
                    href="tel:+234-813-937-7764"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Gloone events business contact number"
                  >
                    <Typography component="span">+234 813 937 7764</Typography>
                  </Button>
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <Button
                    component={ExternalLink}
                    startIcon={<FaWhatsapp />}
                    color="primary"
                    underline="none"
                    href="https://api.whatsapp.com/send?phone=2348139377764"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Gloone events business Whatsapp contact number"
                  >
                    <Typography component="span">Whatsapp Now</Typography>
                  </Button>
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <Button
                    component={ExternalLink}
                    startIcon={<EmailOutlined />}
                    color="primary"
                    underline="none"
                    href="mailto:&#103;&#108;&#111;&#111;&#110;&#101;&#101;&#118;&#101;&#110;&#116;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Gloone events Email address"
                  >
                    <Typography component="span" className={classes.lowerCase}>
                      &#103;&#108;&#111;&#111;&#110;&#101;&#101;&#118;&#101;&#110;&#116;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;
                    </Typography>
                  </Button>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs className={classes.alignLeft}>
              <Typography>OPEN</Typography>
              <List className={classes.List}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primary={"MON - FRI"}
                    secondary={
                      <em className={classes.em}>09:00AM - 04:00PM</em>
                    }
                  />
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primary={"SATURDAYS"}
                    secondary={
                      <em className={classes.em}>10:00AM - 05:00PM</em>
                    }
                  />
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12}>
              <Typography>LOCATION</Typography>
              <List className={classes.List}>
                <ListItem className={classes.ListItem}>
                  15 Adedoyin St, Lawanson, Lagos, Nigeria.
                </ListItem>
              </List>
            </Grid>
          </Grid>
          <Grid
            item
            className={clsx([classes.GridItem, classes.GridItemII])}
            xs={12}
            sm
            md={4}
          >
            <Map />
          </Grid>
          <Grid
            item
            className={clsx([classes.GridItem, classes.GridItemIII])}
            xs={12}
          >
            <Typography className={classes.Logo}>Gloone</Typography>
            <List className={classes.BottomNav}>
              <ListItem>ALL RIGHTS RESERVED @ 2020</ListItem>
              <ListItem>
                <MuiLink
                  color="primary"
                  // className={classes.Link}
                  underline="none"
                  to="/tos"
                  target="_blank"
                >
                  TOS
                </MuiLink>
              </ListItem>
              <ListItem>
                <MuiLink
                  color="primary"
                  // className={classes.Link}
                  underline="none"
                  to="/privacy"
                  target="_blank"
                >
                  PRIVACY POLICY
                </MuiLink>
              </ListItem>
            </List>
          </Grid>
        </Grid>
        <Box className={classes.Ruler}>
          <Box></Box>
        </Box>
      </Box>
    </Box>
  )
}

Footer.propTypes = {
  siteTitle: PropTypes.string,
}

Footer.defaultProps = {
  siteTitle: ``,
}

export default Footer
